import { useTranslation } from "react-i18next";
import { TableInfoDc } from "@evergis/api";

import { useNotification } from "../../../../hooks/notifications/useNotification";

import { LayerInfo } from "../../../../interfaces/resourceInfo";

export const useResultNotifications = (trigger?: boolean, unavailableResources?: Array<LayerInfo | TableInfoDc>) => {
  const { t } = useTranslation("dialogs");

  useNotification(trigger, {
    warning: true,
    title: t("wmsLink.warningTitle"),
    description: `${t("wmsLink.noAccessMessage")} ${unavailableResources[0]?.alias || unavailableResources[0]?.name} ${
      unavailableResources.length > 1
        ? `${t("wmsLink.and")} ${unavailableResources.length - 1} ${t("wmsLink.ofResorces")}`
        : ""
    }`,
  });
};
